import React from 'react';
import SingleColumnTemplate from '@templates/SingleColumn';
import RawHTML from '@components/RawHTML';
import styles from './Profile.module.scss';
import Img from 'gatsby-image';

export default function Profile(props) {
  const { html, frontmatter = {} } = props.data?.markdownRemark ?? {};
  const { name } = frontmatter;
  const title = name ?? 'Profile Not Found';
  const h1 = name ? `About ${name}` : title;
  const content = html ?? `No profile found for ${name ?? 'this person'}.`;
  const breadcrumbs =
    name !== 'Aradhna Tripati'
      ? null
      : [
        { crumbLabel: 'Home', pathname: '/' },
        { crumbLabel: 'About Aradhna', pathname: '/about' },
        { crumbLabel: 'Bio', pathname: '/lab/aradhna-tripati' }
      ];

  return (
    <SingleColumnTemplate
      title={title}
      h1={h1}
      maxWidth={1250}
      contentClassName={styles.wrapper}
      breadcrumbs={breadcrumbs}
    >
      <Sidebar {...frontmatter} />
      <RawHTML>{content}</RawHTML>
    </SingleColumnTemplate>
  );
}

function Sidebar({ photo, name, pronouns, role }) {
  role = role?.split(/\n|\|/).map((text, index) => (
    <span
      className={styles.lineBreak}
      key={index}
    >
      {text}
    </span>
  ));

  // We add details like this in case we decide
  // to add additional fields later (ie Google
  // Scholar or social media links)
  const details = [role]
    .filter(t => t)
    .map((text, index) => <li key={index}>{text}</li>);

  if (pronouns) {
    const parts = pronouns
      .trim()
      .replace(/^\(|\)$/g, '')
      .split('/');

    pronouns = parts.map((p, index) => (
      <span key={index}>{p.trim()}</span>
    ));
  }

  return (
    photo && (
      <div className={styles.sidebar}>
        {photo?.childImageSharp && (
          <div className={styles.photo}>
            <Img
              fixed={[
                {
                  ...photo.childImageSharp.desktop,
                  media: '(min-width: 681px)'
                },
                {
                  ...photo.childImageSharp.desktopSmall,
                  media: '(max-width: 680px) and (min-width: 411px)'
                },
                {
                  ...photo.childImageSharp.mobile,
                  media: '(max-width: 410px)'
                }
              ]}
              fadeIn={false}
              alt={name}
            />
          </div>
        )}
        <ul className={styles.details}>
          <li className={styles.name}>
            <strong>{name}</strong>
            {pronouns && (
              <span className={styles.pronouns}>{pronouns}</span>
            )}
          </li>
          {details}
        </ul>
      </div>
    )
  );
}
